import R from 'ramda';
import { selectYMKMethod } from './helpers';
import { VtoEventsNames } from './hooks/events';

export const onOpenVto = ({
  selectedProduct,
  selectedProductSwatchForEvents,
  onModalOpen,
  eventHandler,
  dispatchEvent,
}) => {
  YMK.openHandAR(true);
  onModalOpen();

  const internalEventHandler = dispatchEvent({
    product: selectedProduct,
    selectedProductSwatch: selectedProductSwatchForEvents,
  });

  internalEventHandler({
    eventName: 'product-try-on',
  });
  eventHandler({ eventName: VtoEventsNames.VTO_PAGE_IMPRESSION });
};

export const onCloseButtonClick = ({
  onModalClose,
  setIsModalOpen,
  setShowStartHero,
  setIsVtoLoaded,
  eventHandler,
}) => {
  onModalClose();
  setIsModalOpen(false);
  setShowStartHero(true);
  setIsVtoLoaded(false);
  eventHandler({ eventName: VtoEventsNames.VTO_GENERIC_EVENT_CLOSED });
};

export const onHeroButtonClick = ({ setShowStartHero, eventHandler }) => {
  setShowStartHero(false);

  eventHandler({
    eventName: VtoEventsNames.VTO_GENERIC_EVENT_GET_STARTED,
  });
};

export const onDropdownSelect = ({
  setVtoActualProductSlug,
  getSelectedProduct,
  productsWithExcludedVariants,
  option,
  dispatchEvent,
  selectedProductSwatch,
  setActiveVariantTab,
  activeTab,
}) => {
  setVtoActualProductSlug({
    actualProductSlug: R.prop('key', option),
  });
  setActiveVariantTab({ activeTab });

  const internalSelectedProduct = getSelectedProduct({
    products: productsWithExcludedVariants,
    actualProductSlug: R.prop('key', option),
  });

  const internalEventHandler = dispatchEvent({
    product: internalSelectedProduct,
    selectedProductSwatch,
  });
  internalEventHandler({
    eventName: VtoEventsNames.VTO_GENERIC_EVENT_SELECT_LINE,
  });
};

export const onSetProductID = ({
  sku,
  swatches,
  selectedProduct,
  setVtoActualProductSku,
  dispatchEvent,
}) => {
  const internalSelectedProductSwatch = R.find(R.propEq('sku', sku), swatches);

  setVtoActualProductSku({ actualProductSku: sku });

  const selectedMethod = selectYMKMethod({
    selectedProductSwatch: internalSelectedProductSwatch,
  });
  selectedMethod(sku);

  const internalEventHandler = dispatchEvent({
    product: selectedProduct,
    selectedProductSwatch: internalSelectedProductSwatch,
  });
  internalEventHandler({
    eventName: VtoEventsNames.VTO_PRODUCT_EVENT_SHADE_SELECT,
  });
};

export const onApplyFiltersButtonClick = ({
  setSelectedFilters,
  appliedFilters,
  eventHandler,
}) => {
  setSelectedFilters({
    selectedFilters: appliedFilters,
  });

  eventHandler({
    eventName: VtoEventsNames.VTO_GENERIC_EVENT_FILTER_APPLY,
    selectedFilters: R.join(
      '|',
      R.map(
        (appliedFilter) =>
          `${R.prop('categoryName', appliedFilter)}:${R.prop(
            'optionName',
            appliedFilter
          )}`,
        appliedFilters
      )
    ),
  });
};

export const onResetFiltersButtonClick = ({
  setSelectedFilters,
  eventHandler,
  selectedFilters,
}) => {
  setSelectedFilters({ selectedFilters: [] });

  eventHandler({
    eventName: VtoEventsNames.VTO_GENERIC_EVENT_FILTER_RESET,
    selectedFilters: R.join(
      '|',
      R.map(
        (selectedFilter) =>
          `${R.prop('categoryName', selectedFilter)}:${R.prop(
            'optionName',
            selectedFilter
          )}`,
        selectedFilters
      )
    ),
  });
};
